import React from "react";
import "../css/about.scss";

function About() {
  return (
    <main className="about-page">
      <section className="about-intro">
        <p className="eyebrow">ABOUT UIGHTPARCEL</p>
        <h1>Clothes for the space between plans.</h1>
        <p>
          Uightparcel is an independent online concept focused on useful
          silhouettes, easy layering and straightforward product information. We
          are building the store carefully, one verified piece at a time.
        </p>
      </section>

      <section
        className="about-art"
        aria-label="Original geometric brand artwork"
        role="img"
      >
        <div className="about-art__block about-art__block--one">
          <span>USE</span>
        </div>
        <div className="about-art__block about-art__block--two">
          <span>KEEP</span>
        </div>
        <div className="about-art__block about-art__block--three">
          <span>REPEAT</span>
        </div>
      </section>

      <section className="about-principles">
        <div className="section-heading">
          <p className="eyebrow">WHAT GUIDES US</p>
          <h2>Four working principles.</h2>
        </div>
        <ol>
          <li>
            <span>01</span>
            <div>
              <h3>Useful first</h3>
              <p>
                Every item should earn its place through comfort, function and
                repeat wear.
              </p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <h3>Plain language</h3>
              <p>
                No invented heritage or vague promises. Claims should be
                specific and supportable.
              </p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <h3>Respect creative work</h3>
              <p>
                We use original or properly licensed visuals, writing and
                product information.
              </p>
            </div>
          </li>
          <li>
            <span>04</span>
            <div>
              <h3>Improve openly</h3>
              <p>
                Policies, accessibility and product information are reviewed as
                the store develops.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <section className="about-status">
        <p className="eyebrow">STORE STATUS</p>
        <h2>A catalogue in progress.</h2>
        <p>
          Online payment is not currently enabled. Product images are original
          AI-generated visual representations used while production photography,
          stock and fulfilment details are being verified. No card details are
          requested or stored on this website.
        </p>
      </section>
    </main>
  );
}

export default About;
